module.exports = __webpack_public_path__ + "static/media/maleFeminine.8d7a7263.png";